/**
 * Shared lightbox controller for gallery-style sections (data-gallery-item
 * tiles with a data-gallery-media <template> inside). Pair with
 * snippets/gallery-lightbox.liquid and assets/gallery-lightbox.css.
 *
 * SBGalleryLightbox.init({
 *   root: <element containing the .sb-gallery__tile triggers>,
 *   lightbox: <the [data-lightbox] element>,
 *   getVisibleItems: <fn returning the current array of clickable tiles>
 * });
 *
 * getVisibleItems is called fresh on every open/step, so a section with
 * filters can hand back a live, filtered array without the lightbox needing
 * to know anything about how filtering works.
 */
window.SBGalleryLightbox = (function () {
  function init(options) {
    var root = options.root;
    var lightbox = options.lightbox;
    var getVisibleItems = options.getVisibleItems;
    if (!root || !lightbox || typeof getVisibleItems !== 'function') return;

    var stage = lightbox.querySelector('[data-lightbox-stage]');
    var captionEl = lightbox.querySelector('[data-lightbox-caption]');
    var creditEl = lightbox.querySelector('[data-lightbox-credit]');
    var currentIndex = -1;

    function renderStage() {
      var item = getVisibleItems()[currentIndex];
      if (!item) return;
      var template = item.querySelector('[data-gallery-media]');
      stage.innerHTML = '';
      if (template) stage.appendChild(template.content.cloneNode(true));

      var caption = item.getAttribute('data-caption') || '';
      var credit = item.getAttribute('data-credit') || '';
      captionEl.textContent = caption;
      captionEl.hidden = !caption;
      creditEl.textContent = credit;
      creditEl.hidden = !credit;
    }

    function open(item) {
      var index = getVisibleItems().indexOf(item);
      if (index === -1) return;
      currentIndex = index;
      renderStage();
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lightbox.hidden = true;
      stage.innerHTML = '';
      document.body.style.overflow = '';
    }

    function step(delta) {
      var items = getVisibleItems();
      if (!items.length) return;
      currentIndex = (currentIndex + delta + items.length) % items.length;
      renderStage();
    }

    Array.prototype.slice.call(root.querySelectorAll('[data-gallery-item]')).forEach(function (item) {
      var trigger = item.querySelector('[data-gallery-trigger]');
      if (trigger) trigger.addEventListener('click', function () { open(item); });
    });

    Array.prototype.slice.call(lightbox.querySelectorAll('[data-lightbox-close]')).forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    // The dialog wrapper covers the full viewport (it centers the stage), so a
    // click anywhere outside the media/buttons lands on the dialog itself
    // rather than the backdrop underneath it — close only when that's the
    // actual click target.
    var dialog = lightbox.querySelector('.sb-lightbox__dialog');
    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) close();
      });
    }

    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') step(-1);
      if (event.key === 'ArrowRight') step(1);
    });
  }

  return { init: init };
})();
